"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Bottom = _interopRequireDefault(require("../01_atoms/Bottom"));

var _Button = _interopRequireDefault(require("../01_atoms/Button"));

var _Container = _interopRequireDefault(require("../01_atoms/Container"));

var _TitledContainer = _interopRequireDefault(require("../01_atoms/TitledContainer"));

var _EditPassengerFormUI = _interopRequireDefault(require("./EditPassengerFormUI"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var EditPassengerForm = /*#__PURE__*/function (_Component) {
  _inherits(EditPassengerForm, _Component);

  var _super = _createSuper(EditPassengerForm);

  function EditPassengerForm() {
    var _this;

    _classCallCheck(this, EditPassengerForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    var sdk = _this.props.sdk;
    _this.state = sdk.passengers.emptyPassenger();
    return _this;
  }

  _createClass(EditPassengerForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // console.log('EditPassengerForm MOUNT');
      var _this$props = this.props,
          sdk = _this$props.sdk,
          defaultValue = _this$props.defaultValue;
      this.setState(_objectSpread({
        id: null
      }, defaultValue || sdk.passengers.emptyPassenger()));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // console.log('EditPassengerForm UPDATE');
      var defaultValue = this.props.defaultValue;

      if (defaultValue !== prevProps.defaultValue) {
        // console.log('EditPassengerForm UPDATE SHOULD MOUNT');
        this.componentDidMount();
      }
    }
  }, {
    key: "onChange",
    value: function onChange(key, value) {
      // console.log(`[EditPassengerForm] onChange(${key},${value})`);
      this.setState(_defineProperty({}, key, value));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // console.log('Rendering EditPassengerForm');
      var _this$props2 = this.props,
          sdk = _this$props2.sdk,
          _this$props2$submitBu = _this$props2.submitButtonLabel,
          submitButtonLabel = _this$props2$submitBu === void 0 ? null : _this$props2$submitBu,
          _this$props2$onSubmit = _this$props2.onSubmit,
          onSubmit = _this$props2$onSubmit === void 0 ? function () {} : _this$props2$onSubmit,
          _this$props2$leftButt = _this$props2.leftButtonLabel,
          leftButtonLabel = _this$props2$leftButt === void 0 ? null : _this$props2$leftButt,
          onLeftButtonClick = _this$props2.onLeftButtonClick,
          _this$props2$leftButt2 = _this$props2.leftButtonColor,
          leftButtonColor = _this$props2$leftButt2 === void 0 ? null : _this$props2$leftButt2,
          translatorForNamespace = _this$props2.translatorForNamespace,
          _this$props2$config = _this$props2.config,
          config = _this$props2$config === void 0 ? {} : _this$props2$config,
          _this$props2$validati = _this$props2.validationRequirement,
          validationRequirement = _this$props2$validati === void 0 ? 'basic' : _this$props2$validati,
          _this$props2$noWrap = _this$props2.noWrap,
          noWrap = _this$props2$noWrap === void 0 ? false : _this$props2$noWrap;
      var t = translatorForNamespace('EditPassengerFormUI'); // FIXME: Smarter validation flexibility? (validating the exact fields selected ?)

      var validationFunc = validationRequirement === 'basic' ? sdk.passengers.validateBasicPassengerInfo : sdk.passengers.validateBillingPassengerInfo;
      var validation = validationFunc(this.state);

      var hasErrors = function hasErrors() {
        for (var _len2 = arguments.length, err = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          err[_key2] = arguments[_key2];
        }

        if (err.length > 1) {
          return err.some(function (e) {
            return hasErrors(e);
          });
        }

        return validation.errors.includes(err[0]);
      };

      var content = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_EditPassengerFormUI["default"], {
        value: this.state,
        onChange: function onChange(newData) {
          return _this2.setState(newData);
        },
        hasErrors: hasErrors,
        translatorForNamespace: translatorForNamespace,
        config: config
      }), /*#__PURE__*/_react["default"].createElement(_Bottom["default"], null, /*#__PURE__*/_react["default"].createElement(_Container["default"], {
        style: {
          display: 'flex'
        }
      }, leftButtonLabel && onLeftButtonClick && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        color: leftButtonColor || null,
        onClick: onLeftButtonClick,
        style: {
          flex: '1',
          margin: 5
        }
      }, leftButtonLabel), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: function onClick() {
          return onSubmit(_this2.state);
        },
        style: {
          flex: '1',
          margin: 5
        },
        primary: true,
        disabled: !validation.isValid
      }, submitButtonLabel || t('Save')))));

      if (noWrap) {
        return content;
      }

      return /*#__PURE__*/_react["default"].createElement(_TitledContainer["default"], {
        title: t('Edit passenger')
      }, content);
    }
  }]);

  return EditPassengerForm;
}(_react.Component);

var _default = EditPassengerForm;
exports["default"] = _default;